import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
    // Function to handle navigation and scrolling ==============
    // ==========================================================
    const handleNavigation = (hash) => {
      if (location.pathname !== "/") {
        navigate('/', { replace: true });
        setTimeout(() => {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' })
          }
        }, 10);
      } else {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  return (
    <footer className="footer">
      <div className="footer-main-row">
        <nav className="footer-nav left-nav">
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/partner-with-us" className="footer-link">Partner With Us</Link>
          <a
            href="https://www.datafre8.com/privacy"
            target="_self"
            className="footer-link"
          >
            Privacy
          </a>
          <Link to="/contact-us" className="footer-link">Contact Us</Link>
        </nav>
        <div className="footer-email right-email">Email: contact@datafre8.com</div>
      </div>
      <div className="footer-icons">
        <a href="https://www.linkedin.com/company/darafre8/" target="_blank" rel="noopener noreferrer">
          <img src="/linkedIn.png" alt="LinkedIn" className="icon" />
        </a>
        <a href="https://medium.com" target="_blank" rel="noopener noreferrer">
          <img src="/medium.png" alt="Medium" className="icon" />
        </a>
      </div>
      <p className="footer-copyright">© 2025 Datafre8. All rights reserved.</p>
    </footer>
  );
};
 
export default Footer;
